import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { take } from 'rxjs';
import moment from 'moment';
import { AuditService } from 'app/services/audit.service';
import { ListaAudit } from 'app/models/audit.model';
import { ExcelApi } from 'app/models/excel.model';
import { ExcelService } from 'app/services/excel.service';
import { saveAs } from 'file-saver';

@Component({
    selector: 'auditoria',
    templateUrl: './auditoria.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AuditoriaComponent implements OnInit {
    constructor(private route: Router, private _audit: AuditService, private _excel: ExcelService) {}

    columns: TableColumn[] = [
        {
            columnDef: 'USUARIO',
            header: 'Usuario (email)',
            headerClass: 'text-left px-1.5 uppercase',
            columnClass: 'pl-6 pr-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'FECHA',
            header: 'Fecha',
            headerClass: 'text-left px-1.5 uppercase',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'date',
            columnFormat: 'dd/MM/YYYY HH:mm:ss',
            columnSort: true,
        },
        {
            columnDef: 'ROL',
            header: 'Rol',
            headerClass: 'text-left px-1.5 uppercase',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'MODULO',
            header: 'Módulo',
            headerClass: 'text-left px-1.5 uppercase',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'ACCION',
            header: 'Acción',
            headerClass: 'text-left px-1.5 uppercase',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
        {
            columnDef: 'TIPO',
            header: 'Tipo',
            headerClass: 'text-left px-1.5 uppercase',
            columnClass: 'px-1.5 paragraph-5 text-left',
            columnClassMobile: 'paragraph-4',
            columnType: 'string',
            columnFormat: '',
            columnSort: true,
        },
    ];
    displayedColumns: string[] = ['email', 'fecha', 'rol', 'modulo', 'accion', 'detalle', 'tipo'];

    search: string = '';
    currentSearch: string = '';
    cargandoDatos: boolean = false;
    loadingExcel: boolean = false;
    showModalDetail: boolean = false;
    detalleOriginal: string = null;
    detalleNuevo: string = null;

    public customPatterns = { '0': { pattern: new RegExp('^[a-zA-ZñÑáéíóúÁÉÍÓÚ .-@_]{1,30}$') } };
    start: moment.Moment = moment().add(-30, 'd');
    end: moment.Moment = moment();

    dataSource: ListaAudit[] = [];

    buscarAudit() {
        this.currentSearch = this.search;
        this.listarAudit();
    }

    ngOnInit() {
        this.listarAudit();
    }

    listarAudit() {
        if (this.start && this.end) {
            let start = this.start.format('yyyy-MM-DD');
            let end = this.end.format('yyyy-MM-DD');
            this._audit
                .listarAudit(this.currentSearch, start, end)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.dataSource = data;
                    },
                    error: (err: any) => {
                        console.log(err);
                        this.dataSource = [];
                    },
                    complete: () => {},
                });
        }
    }

    dateRangeChange($event: any, dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        this.listarAudit();
    }

    onTableAction(row: any) {
        //console.log('ver detalles de', row);
        this.detalleOriginal = row.DETALLE_ORIGINAL;
        this.detalleNuevo = row.DETALLE_ACTUALIZAR;
        this.showModalDetail = true;
    }
    closeModalDetalle() {
        this.showModalDetail = false;
        this.detalleOriginal = null;
        this.detalleNuevo = null;
    }

    descargarExcel() {
        let excel: ExcelApi = {
            config: {
                workSheetName: 'AuditLogs',
                columns: [
                    { tittle: 'USUARIO(EMAIL)', type: 'string', dataKey: 'USUARIO', width: 20 },
                    { tittle: 'FECHA', type: 'string', dataKey: 'FECHA', width: 20 },
                    { tittle: 'ROL', type: 'string', dataKey: 'ROL', width: 20 },
                    { tittle: 'MODULO', type: 'string', dataKey: 'MODULO', width: 30 },
                    { tittle: 'ACCION', type: 'string', dataKey: 'ACCION', width: 20 },
                    { tittle: 'DATA ORIGINAL', type: 'string', dataKey: 'DETALLE_ORIGINAL', width: 200 },
                    { tittle: 'DATA NUEVA', type: 'string', dataKey: 'DETALLE_ACTUALIZAR', width: 200 },
                    { tittle: 'TIPO', type: 'string', dataKey: 'TIPO', width: 20 },
                ],
            },
            arrData: this.dataSource,
        };

        if (excel.arrData.length > 0) {
            this.loadingExcel = true;
            this._excel.generarExcel(excel).subscribe({
                next: (resp) => {
                    saveAs(resp.body, 'AuditLogs');
                    this.loadingExcel = false;
                },
                error: (err) => {
                    //console.log('Err Excel');
                    //console.log(err);
                    this.loadingExcel = false;
                },
                complete: () => {},
            });
        }
    }
}
